import { get, request } from '../../lib/apiClient';

/**
 * The walkthrough video on Home (TOADO-983), as the server builds it from the
 * Vimeo or YouTube link staff set in Admin. Every address here is the
 * server's, built from the video's id, never a link as someone pasted it.
 */
export interface WalkthroughVideo {
  provider: 'vimeo' | 'youtube';
  /** The player, which starts as the modal opens. */
  embedUrl: string;
  /** Where the video lives. */
  watchUrl: string;
  /** A still from the video, or null when none is known. */
  thumbnailUrl: string | null;
}

export interface WalkthroughVideoSetting {
  video: WalkthroughVideo;
  /** Set by staff, rather than the built-in video. */
  custom: boolean;
}

export const WALKTHROUGH_VIDEO_KEY = ['walkthrough-video'] as const;

export const getWalkthroughVideo = () => get<WalkthroughVideoSetting>('/walkthrough-video');

export const setWalkthroughVideo = (url: string) =>
  request<WalkthroughVideoSetting>('/admin/walkthrough-video', { method: 'PUT', body: JSON.stringify({ url }) });

export const resetWalkthroughVideo = () =>
  request<WalkthroughVideoSetting>('/admin/walkthrough-video', { method: 'DELETE' });
